import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

//components
import JobWork from "./JobWork";
import FullPackage from "./FullPackage";
import Button from "../../Buttons/Button";

//services
import {
  SystemServices,
  UtilityService,
  DevelopmentServices,
} from "../../../services";

const fullPackageTemplate = {
  purpose: null,
  date: Date.now(),
  supplierName: null,
  supplierRef: "",
  leadTime: null,
  width: null,
  currency: "rupee",
  price: null,
  MY: "meter",
  GST: null,
  transport: null,
  totalCost: 0,
  currencyData: {},
  moq: "",
  default: false,
  specialComments: "",
};

export default class SupplierSection extends Component {
  state = {
    selected: "",
    currencyOption: [],
    fullPackageData: [
      // {
      //   purpose: null,
      //   date: null,
      //   supplierName: null,
      //   supplierRef: "",
      //   leadTime: null,
      //   width: null,
      //   currency: "rupee",
      //   price: null,
      //   MY: "meter",
      //   GST: null,
      //   transport: null,
      //   totalCost: null,
      //   currencyData: {},
      //   moq: "",
      //   default: false,
      //   specialComments: ""
      // }
    ],
    // jobWorkData: [],
    isLoading: false,
    fabricInfo: [],
    portofpickup: {},
    jobWorkData: [
      {
        rowData: [],
        default: false,
        GST: null,
        moq: "",
        purpose: null,
        transport: null,
        totalLeadTime: null,
        finishedWidth: null,
        cuttableWidth: null,
        totalCost: 0,
        specialComments: "",
      },
    ],
    USDtoINR: null,
    currencyOption: [],
    isLoading: false,
    jobWorkSequence: [],
    jobWorkSequenceValue: {},
    //disabled
    disabled: this.props.disabled,
  };

  componentWillMount = () => {
    console.log("supply ", this.props);

    const { fabricInfo, moduleName, action } = this.props;

    if (this.props.fullPackageData.length > 0) {
      // console.log("coming in if props")
      let { fullPackageData } = this.props;
      fullPackageData = fullPackageData.map((data, i) => {
        let dat = { ...data };
        dat.purposeLabel =
          fullPackageData[i].purpose &&
          fabricInfo &&
          fabricInfo.PURPOSE &&
          fabricInfo.PURPOSE.map((purpose) => {
            if (purpose.value === this.props.fullPackageData.purpose) {
              return purpose.label;
            }
          });
        if (
          data.supplierName !== null &&
          typeof data.supplierName === "object" &&
          Object.keys(data.supplierName).length > 0
        ) {
          dat.supplierName = dat.supplierName._id;
        }
        return dat;
      });

      this.setState({
        fullPackageData,
      });
    } else {
      // console.log("coming in else props")
      let fullPackageData = [];
      let fullPackageTemp = { ...fullPackageTemplate };
      fullPackageData.purposeLabel =
        fullPackageData.purpose &&
        fabricInfo &&
        fabricInfo.PURPOSE &&
        fabricInfo.PURPOSE.map((purpose) => {
          if (purpose.value === fullPackageData.purpose) {
            return purpose.label;
          }
        });
      fullPackageTemp.GST =
        fullPackageTemp.GST === null &&
        this.props.fabricInfo &&
        this.props.fabricInfo.GST &&
        this.props.fabricInfo.GST[0] &&
        this.props.fabricInfo.GST[0].label
          ? this.props.fabricInfo.GST[0].label
          : fullPackageTemp.GST;
      fullPackageTemp.transport =
        fullPackageTemp.transport === null &&
        this.props.fabricInfo &&
        this.props.fabricInfo.TRANSPORT &&
        this.props.fabricInfo.TRANSPORT[0] &&
        this.props.fabricInfo.TRANSPORT[0].label
          ? this.props.fabricInfo.TRANSPORT[0].label
          : fullPackageTemp.transport;
      fullPackageData.push({ ...fullPackageTemp });
      this.setState({
        fullPackageData,
      });
    }
    let jobWorkSequence = [...this.state.jobWorkSequence];
    let jobWorkSequenceValue = { ...this.state.jobWorkSequenceValue };
    fabricInfo &&
      fabricInfo.PROCESS &&
      fabricInfo.PROCESS.map((data, indexOfFabricInfo) => {
        jobWorkSequence.push({ key: indexOfFabricInfo + 1, value: data.label });
        jobWorkSequenceValue[indexOfFabricInfo + 1] = "";
      });
    this.setState({ jobWorkSequence, jobWorkSequenceValue, fabricInfo });
    if (this.props.jobWorkData && this.props.jobWorkData.length > 0) {
      this.props.jobWorkData &&
        this.props.jobWorkData.map((data, index) => {
          data.purposeLabel =
            this.props.jobWorkData[index].purpose &&
            fabricInfo.PURPOSE &&
            fabricInfo.PURPOSE.map((purpose) => {
              if (purpose.value === this.props.jobWorkData[index].purpose) {
                return purpose.label;
              }
            });
        });

      this.setState({
        jobWorkData: this.props.jobWorkData,
        disabled: this.props.disabled,
      });
    } else {
      let jobWorkData = [...this.state.jobWorkData];
      jobWorkData[0].purposeLabel =
        jobWorkData[0].purpose &&
        fabricInfo.PURPOSE &&
        fabricInfo.PURPOSE.map((purpose) => {
          if (purpose.value === this.props.jobWorkData[0].purpose) {
            return purpose.label;
          }
        });
      jobWorkData[0].GST =
        jobWorkData[0].GST === null &&
        this.props.fabricInfo &&
        this.props.fabricInfo.GST &&
        this.props.fabricInfo.GST[0] &&
        this.props.fabricInfo.GST[0].label
          ? this.props.fabricInfo.GST[0].label
          : null;
      jobWorkData[0].transport =
        jobWorkData[0].transport === null &&
        this.props.fabricInfo &&
        this.props.fabricInfo.TRANSPORT &&
        this.props.fabricInfo.TRANSPORT[0] &&
        this.props.fabricInfo.TRANSPORT[0].label
          ? this.props.fabricInfo.TRANSPORT[0].label
          : null;
      jobWorkSequence.forEach(function (data, i) {
        let rowData = {
          key: 0,
          process: "",
          purpose: null,
          supplierRef: null,
          supplierName: null,
          date: Date.now(),
          currency: "rupee",
          leadTime: null,
          width: null,
          price: null,
          vl: null,
          cost: null,
        };
        jobWorkData[0].rowData.push(rowData);
      });
      this.setState({
        jobWorkData,
      });
    }
  };

  componentDidMount() {
    if (this.props.moduleName === "Fabric" && this.props.scrollSupplier) {
      var fullPackageEle = document.getElementById("fullpackage");
      fullPackageEle.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }

    const { fabricInfo, moduleName, action } = this.props;

    if (action === "add") {
      if (!!moduleName) {
        const modulename =
          moduleName.toLowerCase() === "fabric"
            ? "Fabrics"
            : moduleName.toLowerCase() === "trims"
            ? "Trims"
            : null;
        setTimeout(() => {
          SystemServices.getSupplierPart(modulename).then((res) => {
            if (res.message === "Operation Successful") {
              const fullPackageData = [...this.state.fullPackageData];
              const jobWorkData = [...this.state.jobWorkData];
              for (let i = 0; i < fullPackageData.length; i++) {
                fullPackageData[i].currencyData.freightCosts = res.data.freight;
                fullPackageData[i].currencyData.clearance = res.data.clearance;
                fullPackageData[i].currencyData.duty = res.data.duty;
                fullPackageData[i].GST = res.data.gst;
                fullPackageData[i].transport = res.data.transport;
              }

              for (let i = 0; i < jobWorkData.length; i++) {
                jobWorkData[i].GST = res.data.gst;
                jobWorkData[i].transport = res.data.transport;
              }

              const conversionRate = res.data.conversion;
              this.setState({
                // supplierPart: {
                //   fullpackage: fullPackageData
                // },
                USDtoINR: conversionRate,
              });
            }
          });
        }, 1000);
      }
    }

    this.setState({
      fabricInfo,
    });
    if (
      action === "edit" &&
      (this.state.USDtoINR === null || this.state.USDtoINR === undefined)
    ) {
      if (!!moduleName) {
        const modulename =
          moduleName.toLowerCase() === "fabric"
            ? "Fabrics"
            : moduleName.toLowerCase() === "trims"
            ? "Trims"
            : null;
        setTimeout(() => {
          SystemServices.getSupplierPart(modulename).then((res) => {
            if (res.message === "Operation Successful") {
              const fullPackageData = [...this.state.fullPackageData];
              for (let i = 0; i < fullPackageData.length; i++) {
                fullPackageData[i].currencyData.freightCosts =
                  fullPackageData[i].currencyData.freightCosts === null
                    ? res.data.freight
                    : this.state.fullPackageData[i].currencyData.freightCosts;
                fullPackageData[i].currencyData.clearance =
                  fullPackageData[i].currencyData.clearance === null
                    ? res.data.clearance
                    : this.state.fullPackageData[i].currencyData.clearance;
                fullPackageData[i].currencyData.duty =
                  fullPackageData[i].currencyData.duty === null
                    ? res.data.duty
                    : this.state.fullPackageData[i].currencyData.duty;
                fullPackageData[i].GST =
                  fullPackageData[i].GST === null
                    ? res.data.gst
                    : fullPackageData[i].GST;
                fullPackageData[i].transport =
                  fullPackageData[i].transport === null
                    ? res.data.transport
                    : fullPackageData[i].transport;
              }

              const jobWorkData = [...this.state.jobWorkData];
              for (let i = 0; i < jobWorkData.length; i++) {
                // jobWorkData[i].currencyData.freightCosts =
                //   jobWorkData[i].currencyData.freightCosts === null
                //     ? res.data.freight
                //     : this.state.jobWorkData[i].currencyData.freightCosts
                // jobWorkData[i].currencyData.clearance =
                //   jobWorkData[i].currencyData.clearance === null
                //     ? res.data.clearance
                //     : this.state.jobWorkData[i].currencyData.clearance
                // jobWorkData[i].currencyData.duty =
                //   jobWorkData[i].currencyData.duty === null
                //     ? res.data.duty
                //     : this.state.jobWorkData[i].currencyData.duty
                jobWorkData[i].GST =
                  jobWorkData[i].GST === null
                    ? res.data.gst
                    : jobWorkData[i].GST;
                jobWorkData[i].transport =
                  jobWorkData[i].transport === null
                    ? res.data.transport
                    : jobWorkData[i].transport;
              }

              const conversionRate = res.data.conversion;
              this.setState({
                // supplierPart: {
                //   fullpackage: fullPackageData
                // },
                USDtoINR: conversionRate,
              });
            }
          });
        }, 1000);
      }
    }
    setTimeout(() => {
      this.updateFullpackageCalc();
      this.props.getJobWork(this.state.jobWorkData);
    }, 1500);
  }

  componentWillReceiveProps(nextProps) {
    const { supplierSection } = nextProps;
    if (nextProps.supplierSection != this.props.supplierSection) {
      this.setState({
        fullPackageData: supplierSection
          ? supplierSection.fullPackageData
          : null,
        jobWorkData: supplierSection.jobWorkData,
      });
    }

    if (nextProps.fabricInfo != this.props.fabricInfo) {
      this.setState({ fabricInfo: nextProps.fabricInfo });
    }
    if (nextProps.fullPackageData && nextProps.fullPackageData.length > 0) {
      // console.log("coming in if nextProps")
      let fullPackageData = nextProps.fullPackageData;
      // console.log(nextProps.fullPackageData)

      fullPackageData = fullPackageData.map((data) => {
        let dat = { ...data };
        if (
          data._id &&
          data.supplierName !== null &&
          typeof data.supplierName == "object" &&
          Object.keys(data.supplierName).length > 0
        ) {
          dat.supplierName = dat.supplierName.value;
        }
        dat.GST =
          dat.GST === null && nextProps.fabricInfo && nextProps.fabricInfo.GST
            ? nextProps.fabricInfo.GST[0].label
            : dat.GST;
        dat.transport =
          dat.transport === null &&
          nextProps.fabricInfo &&
          nextProps.fabricInfo.TRANSPORT
            ? nextProps.fabricInfo.TRANSPORT[0].label
            : dat.transport;
        return dat;
      });
      this.setState({ fullPackageData });
    } else {
      // console.log("coming in else nextProps")
      // let fullPackageData = [...this.state.fullPackageData]
      // // let fullPackageTemp = { ...fullPackageTemplate }
      // console.log(fullPackageData)
      // fullPackageData[0].GST =
      //   fullPackageData[0].GST === null &&
      //   nextProps.fabricInfo &&
      //   nextProps.fabricInfo.GST &&
      //   nextProps.fabricInfo.GST[0]
      //     ? nextProps.fabricInfo.GST[0].label
      //     : fullPackageData[0].GST
      // fullPackageData[0].transport =
      //   fullPackageData[0].transport === null &&
      //   nextProps.fabricInfo &&
      //   nextProps.fabricInfo.TRANSPORT &&
      //   nextProps.fabricInfo.TRANSPORT[0]
      //     ? nextProps.fabricInfo.TRANSPORT[0].label
      //     : fullPackageData[0].transport
      // // fullPackageData.push({ ...fullPackageData })
      // this.setState({
      //   fullPackageData
      // })
      const { fabricInfo, moduleName, action } = this.props;

      if (!!moduleName) {
        const modulename =
          moduleName.toLowerCase() === "fabric"
            ? "Fabrics"
            : moduleName.toLowerCase() === "trims"
            ? "Trims"
            : null;
        setTimeout(() => {
          SystemServices.getSupplierPart(modulename).then((res) => {
            if (res.message === "Operation Successful") {
              const fullPackageData = [...this.state.fullPackageData];
              const jobWorkData = [...this.state.jobWorkData];
              for (let i = 0; i < fullPackageData.length; i++) {
                fullPackageData[i].currencyData.freightCosts = res.data.freight;
                fullPackageData[i].currencyData.clearance = res.data.clearance;
                fullPackageData[i].currencyData.duty = res.data.duty;
                fullPackageData[i].GST = res.data.gst;
                fullPackageData[i].transport = res.data.transport;
              }

              for (let i = 0; i < jobWorkData.length; i++) {
                jobWorkData[i].GST = res.data.gst;
                jobWorkData[i].transport = res.data.transport;
              }

              const conversionRate = res.data.conversion;
              this.setState({
                // supplierPart: {
                //   fullpackage: fullPackageData
                // },
                USDtoINR: conversionRate,
              });
            }
          });
        }, 1000);
      }
    }
    if (nextProps.fabricInfo != this.props.fabricInfo) {
      this.setState({
        fabricInfo: nextProps.fabricInfo,
      });
    }

    if (nextProps.fabricInfo != this.props.fabricInfo) {
      const { fabricInfo } = nextProps;
      this.setState({ fabricInfo });

      var jobWorkSequence = [...this.state.jobWorkSequence];
      let jobWorkSequenceValue = { ...this.state.jobWorkSequenceValue };

      fabricInfo &&
        fabricInfo.PROCESS &&
        fabricInfo.PROCESS.map((data, indexOfFabricInfo) => {
          jobWorkSequence.push({
            key: indexOfFabricInfo + 1,
            value: data.label,
          });
          jobWorkSequenceValue[indexOfFabricInfo + 1] = "";
        });

      this.setState({ jobWorkSequence, jobWorkSequenceValue });

      if (nextProps.jobWorkData && nextProps.jobWorkData.length > 0) {
        let jobWorkData = [...nextProps.jobWorkData];
        jobWorkData = jobWorkData.map((data) => {
          let dat = { ...data };
          if (typeof data.supplierName == "object") {
            dat.supplierName = data.supplierName.value;
          }
          return dat;
        });

        this.setState({
          jobWorkData: nextProps.jobWorkData,
          disabled: nextProps.disabled,
        });
      } else {
        let jobWorkData = [...this.state.jobWorkData];
        jobWorkData[0].GST =
          jobWorkData[0].GST === null &&
          nextProps.fabricInfo &&
          nextProps.fabricInfo.GST
            ? nextProps.fabricInfo.GST[0].label
            : null;
        jobWorkData[0].transport =
          jobWorkData[0].transport === null &&
          nextProps.fabricInfo &&
          nextProps.fabricInfo.TRANSPORT
            ? nextProps.fabricInfo.TRANSPORT[0].label
            : null;
        jobWorkSequence.forEach(function (data, i) {
          let rowData = {
            key: 0,
            process: "",
            purpose: null,
            supplierRef: null,
            supplierName: null,
            date: Date.now(),
            currency: "rupee",
            leadTime: null,
            width: null,
            price: null,
            vl: null,
            cost: null,
          };
          jobWorkData[0].rowData.push(rowData);
        });

        this.setState({
          jobWorkData,
        });
      }
    }
  }

  // fullpackage

  addFullPackageCount = () => {
    const { moduleName } = this.props;
    const modulename =
      moduleName.toLowerCase() === "fabric"
        ? "Fabrics"
        : moduleName.toLowerCase() === "trims"
        ? "Trims"
        : null;
    let fullPackageData = [...this.state.fullPackageData];
    const fullPackageTemp = { ...fullPackageTemplate };

    SystemServices.getSupplierPart(modulename).then((res) => {
      if (res.message === "Operation Successful") {
        fullPackageTemp.currencyData.freightCosts = res.data.freight;
        fullPackageTemp.currencyData.clearance = res.data.clearance;
        fullPackageTemp.currencyData.duty = res.data.duty;
        fullPackageTemp.GST = res.data.gst;
        fullPackageTemp.transport = res.data.transport;
        fullPackageData.push({ ...fullPackageTemp });
        const conversionRate = res.data.conversion;
        this.setState({
          fullPackageData,
          USDtoINR: conversionRate,
        });
      }
    });
  };

  updateMoqSupplierSectionHandler = (name, value, index) => {
    let fullPackageData = [...this.state.fullPackageData];
    fullPackageData[index][name] = value;

    this.setState({
      fullPackageData,
    });
  };

  updateValueFull = (name, value, index) => {
    const { moduleName } = this.props;
    const modulename =
      moduleName.toLowerCase() === "fabric"
        ? "Fabrics"
        : moduleName.toLowerCase() === "trims"
        ? "Trims"
        : null;
    let fullPackageData = [...this.state.fullPackageData];
    fullPackageData[index][name] = value;
    if (fullPackageData[index].currency === "dollar") {
      SystemServices.getSupplierPart(modulename).then((res) => {
        if (res.message === "Operation Successful") {
          fullPackageData[index].currencyData = {
            clearance: res.data.clearance,
            duty: res.data.duty,
            freightCosts: res.data.freight,
            shipmentMode: null,
            portOfPickup: null,
            shipmentTerm: null,
            totalOrderQuantity: null,
            width: null,
            gsm: null,
            weightOfFabricPerMtr: null,
            weightForFullOrder: null,
            freightRatePerKg: null,
          };

          this.setState(
            {
              fullPackageData,
            },
            () => this.updateFullpackageCalc()
          );
        }
      });
    } else {
      this.setState(
        {
          fullPackageData,
        },
        () => this.updateFullpackageCalc()
      );
    }
  };

  updateINRCurrency = (e) => {
    const USDtoINR = e.target.value;

    this.setState(
      {
        USDtoINR,
      },
      () => this.updateFullpackageCalc()
    );
  };

  removeFullPackage = (index) => {
    let fullPackageData = [...this.state.fullPackageData];
    fullPackageData.splice(index, 1);
    // fullPackageData = fullPackageData.filter((data, i) => i !== index)
    this.setState(
      {
        fullPackageData,
      },
      () => this.props.getFullPackage(fullPackageData)
    );
  };

  _inputForCurrency = (name, value, index) => {
    let fullPackageData = [...this.state.fullPackageData];
    if (name === "portOfPickup") {
      if (value) {
        fullPackageData[index].currencyData[name] = value;
      } else {
        fullPackageData[index].currencyData[name] = null;
      }
    } else {
      fullPackageData[index].currencyData[name] = value;
    }
    this.setState(
      {
        fullPackageData,
      },
      () => this.updateFullpackageCalc()
    );
  };

  updateFullpackageCalc() {
    let fullPackageData = [...this.state.fullPackageData];

    fullPackageData.map((data, index) => {
      if (fullPackageData[index].currency !== "dollar") {
        if (fullPackageData[index].price) {
          fullPackageData[index].totalCost = +fullPackageData[index].price;
        }
        if (
          fullPackageData[index].price &&
          fullPackageData[index].GST &&
          fullPackageData[index].transport
        ) {
          fullPackageData[index].totalCost =
            +fullPackageData[index].price +
            +(
              fullPackageData[index].price *
              (fullPackageData[index].GST / 100)
            ) +
            +fullPackageData[index].transport;
          fullPackageData[index].totalCost = (
            fullPackageData[index].totalCost * 1
          ).toFixed(3);
        }
      } else if (fullPackageData[index].currency == "dollar") {
        if (fullPackageData[index].price) {
          if (fullPackageData[index].MY == "yard") {
            fullPackageData[index].currencyData.priceMTS = (
              fullPackageData[index].price / 0.9144
            ).toFixed(3);
            fullPackageData[index].currencyData.conversionToINR = (
              fullPackageData[index].currencyData.priceMTS * this.state.USDtoINR
            ).toFixed(3);
          } else if (fullPackageData[index].MY == "meter") {
            fullPackageData[index].currencyData.priceMTS =
              fullPackageData[index].price;
            fullPackageData[index].currencyData.conversionToINR = (
              fullPackageData[index].currencyData.priceMTS * this.state.USDtoINR
            ).toFixed(3);
          } else if (fullPackageData[index].MY === "gross") {
            fullPackageData[index].currencyData.priceMTS = Number(
              fullPackageData[index].price / 144
            ).toFixed(3);
            fullPackageData[index].currencyData.conversionToINR = Number(
              fullPackageData[index].currencyData.priceMTS * this.state.USDtoINR
            ).toFixed(3);
          } else if (
            fullPackageData[index].MY === "pcs" ||
            fullPackageData[index].MY === "sets"
          ) {
            fullPackageData[index].currencyData.priceMTS = Number(
              fullPackageData[index].price
            ).toFixed(3);
            fullPackageData[index].currencyData.conversionToINR = Number(
              fullPackageData[index].currencyData.priceMTS * this.state.USDtoINR
            ).toFixed(3);
          } else {
            fullPackageData[index].currencyData.priceMTS = Number(
              fullPackageData[index].price
            ).toFixed(3);
            fullPackageData[index].currencyData.conversionToINR = Number(
              fullPackageData[index].currencyData.priceMTS * this.state.USDtoINR
            ).toFixed(3);
          }

          fullPackageData[index].totalCost = (
            +fullPackageData[index].currencyData.conversionToINR +
            +fullPackageData[index].currencyData.freightCosts +
            +fullPackageData[index].currencyData.clearance +
            (+fullPackageData[index].currencyData.conversionToINR +
              +fullPackageData[index].currencyData.freightCosts +
              +fullPackageData[index].currencyData.clearance) *
              (fullPackageData[index].currencyData.duty / 100)
          ).toFixed(3);
        }

        if (
          fullPackageData[index].currencyData.shipmentTerm == "FOB" &&
          fullPackageData[index].currencyData.shipmentMode == "SEA"
        ) {
          if (fullPackageData[index].currencyData.portOfPickup) {
            var portofpickup;

            this.state.fabricInfo.PORTOFPICKUP.map((data) => {
              if (
                data.name === fullPackageData[index].currencyData.portOfPickup
              ) {
                portofpickup = data;
                this.setState({ portofpickup: data }, () => {});
                fullPackageData[index].currencyData.freightCosts =
                  portofpickup.seaFreightCost;
              }
            });

            fullPackageData[index].totalCost = (
              +fullPackageData[index].currencyData.conversionToINR +
              +fullPackageData[index].currencyData.freightCosts +
              +fullPackageData[index].currencyData.clearance +
              (+fullPackageData[index].currencyData.conversionToINR +
                +fullPackageData[index].currencyData.freightCosts +
                +fullPackageData[index].currencyData.clearance) *
                (fullPackageData[index].currencyData.duty / 100)
            ).toFixed(3);
          }
        }

        if (
          fullPackageData[index].currencyData.shipmentTerm == "CIF" &&
          fullPackageData[index].currencyData.shipmentMode == "SEA"
        ) {
          if (fullPackageData[index].currencyData.portOfPickup) {
            fullPackageData[index].currencyData.freightCosts = 0;
          }
        }

        if (
          fullPackageData[index].currencyData.shipmentTerm == "FOB" &&
          fullPackageData[index].currencyData.shipmentMode == "AIR"
        ) {
          fullPackageData[index].currencyData.freightCosts = 0;
        }

        if (
          fullPackageData[index].currencyData.width > 0 &&
          fullPackageData[index].currencyData.gsm > 0
        ) {
          fullPackageData[index].currencyData.weightOfFabricPerMtr = (
            (fullPackageData[index].currencyData.gsm *
              fullPackageData[index].currencyData.width) /
            40 /
            1000
          ).toFixed(3);
        }

        if (
          fullPackageData[index].currencyData.weightOfFabricPerMtr > 0 &&
          fullPackageData[index].currencyData.totalOrderQuantity > 0
        ) {
          fullPackageData[index].currencyData.weightForFullOrder = (
            fullPackageData[index].currencyData.weightOfFabricPerMtr *
            fullPackageData[index].currencyData.totalOrderQuantity
          ).toFixed(3);
        }

        if (fullPackageData[index].currencyData.weightForFullOrder > 0) {
          if (fullPackageData[index].currencyData.weightForFullOrder >= 500) {
            var portofpickup;
            if (fullPackageData[index].currencyData.portOfPickup) {
              this.state.fabricInfo.PORTOFPICKUP.map((data) => {
                if (
                  data.name === fullPackageData[index].currencyData.portOfPickup
                ) {
                  portofpickup = data;
                }
              });
            }
            fullPackageData[index].currencyData.freightRatePerKg =
              portofpickup.freightCostAbove500;
            if (
              fullPackageData[index].currencyData.shipmentTerm !== "CIF" &&
              fullPackageData[index].currencyData.shipmentMode !== "AIR"
            ) {
              fullPackageData[index].currencyData.freightCosts =
                fullPackageData[index].currencyData.freightRatePerKg *
                fullPackageData[index].currencyData.weightOfFabricPerMtr;
            } else {
              fullPackageData[index].currencyData.freightCosts = 0;
            }
          }
          if (fullPackageData[index].currencyData.weightForFullOrder < 500) {
            var portofpickup;
            if (fullPackageData[index].currencyData.portOfPickup) {
              this.state.fabricInfo.PORTOFPICKUP.map((data) => {
                if (
                  data.name === fullPackageData[index].currencyData.portOfPickup
                ) {
                  portofpickup = data;
                }
              });
            }

            fullPackageData[index].currencyData.freightRatePerKg =
              portofpickup.freightCostBelow500;
            if (
              fullPackageData[index].currencyData.shipmentTerm !== "CIF" &&
              fullPackageData[index].currencyData.shipmentMode !== "AIR"
            ) {
              fullPackageData[index].currencyData.freightCosts =
                fullPackageData[index].currencyData.freightRatePerKg *
                fullPackageData[index].currencyData.weightOfFabricPerMtr;
            } else {
              fullPackageData[index].currencyData.freightCosts = 0;
            }
          }

          fullPackageData[index].totalCost = (
            +fullPackageData[index].currencyData.conversionToINR +
            +fullPackageData[index].currencyData.freightCosts +
            +fullPackageData[index].currencyData.clearance +
            (+fullPackageData[index].currencyData.conversionToINR +
              +fullPackageData[index].currencyData.freightCosts +
              +fullPackageData[index].currencyData.clearance) *
              (fullPackageData[index].currencyData.duty / 100)
          ).toFixed(3);
        }
      }
    });

    this.setState({ fullPackageData }, () =>
      this.props.getFullPackage(fullPackageData)
    );
  }

  // // //

  // job work
  //Add job work
  addJobWork = () => {
    let { moduleName } = this.props;
    moduleName =
      moduleName.toLowerCase() === "fabric"
        ? "Fabrics"
        : moduleName.toLowerCase() === "trims"
        ? "Trims"
        : null;
    let jobWorkData = [...this.state.jobWorkData];
    let rowData = [];

    this.state.jobWorkSequence.forEach(function (data, i) {
      let rowData1 = {
        key: 0,
        process: "",
        purpose: null,
        supplierRef: null,
        supplierName: null,
        date: Date.now(),
        currency: "rupee",
        leadTime: null,
        width: null,
        price: null,
        vl: null,
        cost: null,
      };
      rowData.push(rowData1);
    });

    SystemServices.getSupplierPart(moduleName).then((res) => {
      if (res.message === "Operation Successful") {
        let item = {
          rowData: [...rowData],
          default: false,
          toggle: false,
          GST: res.data.gst,
          transport: res.data.transport,
          totalLeadTime: null,
          finishedWidth: null,
          cuttableWidth: null,
          totalCost: 0,
          specialComments: "",
        };

        jobWorkData.push(item);
        this.setState({ jobWorkData });
      }
    });
  };

  //remove JobWork
  removeJobWork = (index) => {
    let jobWorkData = [...this.state.jobWorkData];

    jobWorkData.splice(index, 1);

    this.setState({ jobWorkData }, () =>
      this.props.getJobWork(this.state.jobWorkData)
    );
  };

  addingRow = (e, index, key) => {
    let jobWorkData = [...this.state.jobWorkData];
    let jobWorkSequenceValue = { ...this.state.jobWorkSequenceValue };
    if (e.target.value !== "") {
      jobWorkData[index]["rowData"][key - 1]["key"] =
        this.state.jobWorkSequence[e.target.value - 1].key;
      jobWorkData[index]["rowData"][key - 1]["process"] =
        this.state.jobWorkSequence[e.target.value - 1].value;
    } else {
      jobWorkData[index]["rowData"][key - 1]["key"] = "";
      jobWorkData[index]["rowData"][key - 1]["process"] = "";
    }
    jobWorkSequenceValue[key] = e.target.value;

    this.setState({ jobWorkData, jobWorkSequenceValue });
  };

  //updating job work
  updateJobworkRow = (name, value, index, i) => {
    let jobWorkData = [...this.state.jobWorkData];
    jobWorkData[i].rowData[index][name] = value;
    this.setState(
      {
        jobWorkData,
      },
      this.props.getJobWork(jobWorkData),
      this.updateJobWorkRowDataTotalCost()
    );
  };

  updateJobworkDataKeyValue = (e, i) => {
    let jobWorkData = [...this.state.jobWorkData];
    let nameValue = e.target.name;
    jobWorkData[i][nameValue] = e.target.value;
    this.setState({ jobWorkData }, () => this.props.getJobWork(jobWorkData));
  };

  // updateForDefaultDefault = (name, value, index) => {
  //   let jobWorkData = [...this.state.jobWorkData];
  //   jobWorkData[index]["default"] = !jobWorkData[index]["default"];
  //   jobWorkData = jobWorkData.map((data, i) => {
  //     let dat = { ...data };
  //     if (i != index) {
  //       dat["default"] = false;
  //     }
  //     return dat;
  //   });

  //   this.setState({ jobWorkData }, () => {
  //     this.props.getFullPackage(this.state.fullPackageData);
  //     this.props.getJobWork(jobWorkData);
  //   });
  // };

  updateValueJob = (name, value, index) => {
    let jobWorkData = [...this.state.jobWorkData];
    jobWorkData[index][name] = value;
    this.setState({ jobWorkData });
  };

  // updating calc in job work row data
  updateJobWorkRowDataTotalCost = () => {
    let jobWorkData = [...this.state.jobWorkData];
    jobWorkData.map((data, i) => {
      var totalCost = 0;
      var cost = 0;
      data.rowData.map((row, index) => {
        if (row.price) {
          var previousprice = cost + Number(row.price);
          var percentValue = 0;
          // if(index == 0){
          //   previousprice = parseInt(row.price)
          // }
          if (row.vl) {
            var perc = parseInt(row.vl) / 100;
            percentValue = previousprice * perc;
          }
          cost = Number(percentValue) + Number(previousprice);
          jobWorkData[i].rowData[index].cost = UtilityService.round(cost);
          totalCost = cost;
        }
      });
      if (data.GST) {
        totalCost += totalCost * (parseInt(data.GST) / 100);
      }
      if (data.transport) {
        totalCost += parseInt(data.transport);
      }
      jobWorkData[i].totalCost = totalCost.toFixed(3);
    });

    this.setState({
      jobWorkData,
    });
  };

  // ///   ///

  // onSubmit = () => { }

  //getDataFrom full package component
  // getFullPackage = fullPackageData => {
  //   this.setState(
  //     {
  //       fullPackageData
  //     },
  //     () => this.props.getSupplier(fullPackageData, "fullPackageData")
  //   );
  // };

  // getJobWork = jobWorkData => {
  //
  //   this.setState(
  //     {
  //       jobWorkData
  //     },
  //     () => this.props.getSupplier(jobWorkData, "jobWorkData")
  //   );
  // };

  updateValueForDefault = (name, value, index, keyName, data) => {
    // let supplierSection = {};
    let fullPackageData, jobWorkData;
    if (keyName === "fullpackage") {
      fullPackageData = [...this.state.fullPackageData];
      fullPackageData[index].default = !fullPackageData[index].default;
      fullPackageData = fullPackageData.map((data, i) => {
        if (i !== index) {
          data.default = false;
        }
        return data;
      });
      jobWorkData = this.state.jobWorkData.map((data) => {
        data.default = false;
        return data;
      });
    }
    if (keyName === "jobwork") {
      jobWorkData = [...this.state.jobWorkData];
      jobWorkData[index]["default"] = !jobWorkData[index]["default"];
      jobWorkData = jobWorkData.map((data, i) => {
        let dat = { ...data };
        if (i != index) {
          dat["default"] = false;
        }
        return dat;
      });

      fullPackageData = this.state.fullPackageData.map((data) => {
        data.default = false;
        return data;
      });
    }

    this.setState({ fullPackageData, jobWorkData }, () => {
      this.props.getFullPackage(this.state.fullPackageData);
      this.props.getJobWork(this.state.jobWorkData);
    });
  };

  createSuppier = (e) => {
    let data = {};

    let supplierSection = {};

    if (this.state.fullPackageData && this.state.fullPackageData.length > 0) {
      supplierSection.fullPackageData = [...this.state.fullPackageData];
    }

    if (this.state.jobWorkData && this.state.jobWorkData.length > 0) {
      supplierSection.jobWorkData = [...this.state.jobWorkData];
    }
    data._id = this.props._id;
    data.supplierSection = supplierSection;
    if (this.props.moduleName == "Fabric") {
      data.toggle = { ...this.props.toggle };
    }

    if (
      supplierSection.jobWorkData &&
      supplierSection.jobWorkData.length > 0 &&
      supplierSection.fullPackageData &&
      supplierSection.fullPackageData.length > 0
    ) {
      let count = 0;
      supplierSection.fullPackageData.map((datafull) => {
        if (datafull.default) {
          count++;
        }
      });
      supplierSection.jobWorkData.map((datajob) => {
        if (datajob.default) {
          count++;
        }
      });
      if (count > 1) {
        this.props.getalertMessage("error", " Default price must be one ");
      } else {
        DevelopmentServices.createSupplierForFabric(
          data,
          this.props.moduleName === "Fabric"
            ? "fabric"
            : this.props.moduleName === "trims"
            ? "trim"
            : ""
        ).then((response) => {
          if (response.status === 200) {
            this.props.getalertMessage("success", " Supplier created ");
          }
          response.status === 401 && this.props.unauthorisedFunc();
        });
      }
    } else {
      DevelopmentServices.createSupplierForFabric(
        data,
        this.props.moduleName === "Fabric"
          ? "fabric"
          : this.props.moduleName === "trims"
          ? "trim"
          : ""
      ).then((response) => {
        if (response.status === 200) {
          this.props.getalertMessage("success", " Supplier created ");
        }
        response.status === 401 && this.props.unauthorisedFunc();
      });
    }
  };

  render() {
    return (
      <div className="col-md-12 py-0 px-5" id="supplierParrt">
        <h6 className="text-green font-lg font-weight-bold">
          <b>Supplier</b>
        </h6>
        <Fragment>
          <FullPackage
            moduleName={this.props.moduleName}
            action={this.props.action}
            scrollSupplier={this.props.scrollSupplier}
            suppliersOption={this.props.suppliersOption}
            currencyOption={this.state.currencyOption}
            fullPackageData={this.state.fullPackageData}
            disabled={this.state.disabled}
            fabricInfo={this.state.fabricInfo}
            updateValueForDefault={this.updateValueForDefault}
            updateValue={this.updateValueFull}
            addFullPackageCount={this.addFullPackageCount}
            removeFullPackage={this.removeFullPackage}
            _inputForCurrency={this._inputForCurrency}
            updateFullpackageCalc={this.updateFullpackageCalc}
            updateINRCurrency={this.updateINRCurrency}
            USDtoINR={this.state.USDtoINR}
            updateMoqSupplierSectionHandler={
              this.updateMoqSupplierSectionHandler
            }
          />
          <JobWork
            moduleName={this.props.moduleName}
            suppliersOption={this.props.suppliersOption}
            currencyOption={this.state.currencyOption}
            jobWorkData={this.state.jobWorkData}
            fabricInfo={this.state.fabricInfo}
            disabled={this.state.disabled}
            scrollSupplier={this.props.scrollSupplier}
            jobWorkSequence={this.state.jobWorkSequence}
            updateValueForDefault={this.updateValueForDefault}
            updateValue={this.updateValueJob}
            addJobWork={this.addJobWork}
            addingRow={this.addingRow}
            removeJobWork={this.removeJobWork}
            updateJobWorkRowDataTotalCost={this.updateJobWorkRowDataTotalCost}
            updateJobworkDataKeyValue={this.updateJobworkDataKeyValue}
            updateJobworkRow={this.updateJobworkRow}
          />
          <div className="col-md-12 text-center profile-btn">
            {!this.props.disabled && (
              <Button
                buttonType="save"
                buttonName="save"
                onClick={this.createSuppier}
              />
            )}
            <Button
              history={this.props.history}
              buttonType="cancel"
              buttonName="Cancel"
            />
          </div>
        </Fragment>
      </div>
    );
  }
}

SupplierSection.propTypes = {};

SupplierSection.defaultProps = {};



// WEBPACK FOOTER //
// ./src/components/SupplierSection/SupplierMain/SupplierSection.js